/**
 * Chuyển hướng SSO từ Auth → app con (`setting-token?redirect_url=...&token=...`).
 * Dùng cùng tab (replace) — không mở tab mới, không `return null` (tránh màn trắng).
 */

const CONSUMER_REDIRECT_ENV: Record<string, string | undefined> = {
  kho: process.env.REACT_APP_KHO_REDIRECT,
  muahang: process.env.REACT_APP_MUAHANG_REDIRECT,
  sanxuat: process.env.REACT_APP_SANXUAT_REDIRECT,
  banhang: process.env.REACT_APP_BANHANG_REDIRECT,
}

export function getSsoConsumerBase(heThong: string | null | undefined): string {
  if (!heThong) return ''
  return String(CONSUMER_REDIRECT_ENV[heThong] || '').trim()
}

export function buildSsoConsumerUrl(
  heThong: string,
  redirectUrl: string | null | undefined,
  token: string,
): string | null {
  const base = getSsoConsumerBase(heThong)
  if (!base || !token) return null
  const path = redirectUrl && String(redirectUrl).trim() ? String(redirectUrl).trim() : '/'
  // base dạng: https://app/setting-token?redirect_url=
  return `${base}${encodeURIComponent(path)}&token=${encodeURIComponent(token)}`
}

/** Redirect cùng tab; trả true nếu đã chuyển hướng. */
export function redirectToSsoConsumer(
  heThong: string | null | undefined,
  redirectUrl: string | null | undefined,
  token: string,
): boolean {
  if (!heThong) return false
  const url = buildSsoConsumerUrl(heThong, redirectUrl, token)
  if (!url) return false
  window.location.replace(url)
  return true
}
